

export default {
  props: {
    center: {
      type: Array,
    },
    zoom: {
      type: Number,
    },
    coordinates: {
      type: Array,
    },
  },
  data() {
    return {
      classrooms: [],
      locations: [],
      isMapboxLoaded:false,
      accessToken:
        'pk.eyJ1IjoiamFrZXRlZmwiLCJhIjoiY2lveTg0ZW94MDBjeHZtbTJ3bmRkZzA1aCJ9.EDGQY9zwCqaxTHVGc7DK8w', // your access token. Needed if you using Mapbox maps
      mapStyle: 'mapbox://styles/mapbox/light-v10', // your map style
      //   zoom: 12,
      //  center: [-1.17432, 52.355518],
      map: {},
    }
  },
 head() {
    return {
      link: [
        {
          rel: 'stylesheet',
          href: 'https://api.mapbox.com/mapbox-gl-js/v2.7.0/mapbox-gl.css',
        },
      ],
      script: [
            {
              hid: 'mapboxgl',
              src: 'https://api.mapbox.com/mapbox-gl-js/v2.7.0/mapbox-gl.js',
              defer: true,
              // Changed after script load
              callback: () => { this.isMapboxLoaded = true } 
            },
            {
              hid: 'turfjs',
              src: 'https://npmcdn.com/@turf/turf/turf.min.js',
              defer: true
            }
          ]
    }
  },
  methods: {
  visibilityChanged (isVisible, entry) {
  this.isVisible = isVisible
 if(isVisible)
 this.createMap()
},
 async   createMap() {
      try {
       window.mapboxgl.accessToken = this.accessToken
        this.map = new window.mapboxgl.Map({
          container: 'map',
          style: 'mapbox://styles/mapbox/streets-v11',
          center: this.$props.center,
          zoom: this.$props.zoom,
          cooperativeGestures: true,
          attributionControl:false
        })
       await this.$props.coordinates.map((location) => {
         if (location.venue){
            return new window.mapboxgl.Marker({
              draggable: false,
              color: '#F76386',
            })
            .setLngLat([location.long, location.lat])
            .setPopup(new window.mapboxgl.Popup().setHTML(`<h1>TEFL Courses in ${location.town}</h1>
            ${location.venue.name},
            ${location.venue.line1},
            ${location.venue.town},
             ${location.venue.postcode}
            `)) // add popup 
            .addTo(this.map)
            }
            else{
              return new window.mapboxgl.Marker({
                draggable: false,
                color: '#F76386',
              })
              .setLngLat([location.long, location.lat])
              .addTo(this.map)
            }
            
      
        })
        this.map.scrollZoom.disable();
        this.map.addControl(new window.mapboxgl.NavigationControl());
      } catch (err) {
        console.log('map error', err)
      }
    },
  },
}
